var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVialLabelDataLinkageExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1458.75 520.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st1, .st3, .st7 {\n        stroke-width: 2.5px;\n      }\n\n      .st0, .st3, .st7 {\n        stroke: #e59648;\n      }\n\n      .st0, .st5 {\n        fill: #f7e7d0;\n      }\n\n      .st1, .st2, .st7 {\n        fill: #d3e0f1;\n      }\n\n      .st1, .st5 {\n        stroke: #2151c4;\n      }\n\n      .st2, .st4 {\n        stroke: #aeaeae;\n      }\n\n      .st3 {\n        fill: #f9e6cd;\n      }\n\n      .st9, .st10 {\n        font-size: 36px;\n      }\n\n      .st9, .st11 {\n        font-family: HelveticaNeue-Medium, 'Helvetica Neue';\n        font-weight: 500;\n      }\n\n      .st4, .st6 {\n        fill: #fff;\n      }\n\n      .st12 {\n        fill: #4172d0;\n      }\n\n      .st12, .st13, .st14, .st15, .st16 {\n        font-family: HelveticaNeue-Bold, 'Helvetica Neue';\n        font-weight: 700;\n      }\n\n      .st12, .st13, .st14, .st16 {\n        font-size: 16px;\n      }\n\n      .st13 {\n        fill: #78a558;\n      }\n\n      .st17 {\n        fill: #666;\n      }\n\n      .st14 {\n        fill: #da9346;\n      }\n\n      .st6 {\n        stroke: #ea3323;\n        stroke-width: 3.5px;\n      }\n\n      .st8 {\n        fill: none;\n        stroke: #666;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 287.5,
    y: 352.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 517.5,
    y: 352.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 287.5,
    y: 407.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 517.5,
    y: 407.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 287.5,
    y: 297.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 517.5,
    y: 297.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 57.5,
    y: 352.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 57.5,
    y: 407.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 57.5,
    y: 297.88,
    width: 230,
    height: 55
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 997.5,
    y: 352.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1227.5,
    y: 352.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 997.5,
    y: 407.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1227.5,
    y: 407.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 997.5,
    y: 297.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 1227.5,
    y: 297.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 767.5,
    y: 352.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 767.5,
    y: 407.88,
    width: 230,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 767.5,
    y: 297.88,
    width: 230,
    height: 55
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 57.5,
    y: 103.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 457.5,
    y: 103.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 657.5,
    y: 103.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 857.5,
    y: 103.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1057.5,
    y: 103.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1257.5,
    y: 103.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 57.5,
    y: 158.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 457.5,
    y: 158.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 657.5,
    y: 158.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 857.5,
    y: 158.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1057.5,
    y: 158.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1257.5,
    y: 158.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 57.5,
    y: 48.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 257.5,
    y: 48.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 457.5,
    y: 48.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 657.5,
    y: 48.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 857.5,
    y: 48.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 1057.5,
    y: 48.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 1257.5,
    y: 48.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 257.5,
    y: 103.88,
    width: 200,
    height: 55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 257.5,
    y: 158.88,
    width: 200,
    height: 55
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(65.5 386.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ENSRNOG00000000001")), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(386.93 386.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18.0")), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(621.38 386.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2.0")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(65.5 441.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ENSRNOG00000000007")), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(386.93 441.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10.0")), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(621.38 441.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6.0")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(65.5 331.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "gene_id")), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(356.44 331.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sample_01a")), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(586.44 331.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sample_02a")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(775.5 386.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Compound_01")), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(1101.38 386.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3.5")), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(1331.38 386.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2.0")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(775.5 441.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Compound_02")), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(1101.38 441.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1.3")), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(1331.38 441.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0.7")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(775.5 331.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "metabolite_name")), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(1066.14 331.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sample_01b")), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(1296.14 331.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sample_02b")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(65.5 137.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sample_01a")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(265.5 137.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10029885")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(465.5 137.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "One-week program")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(665.5 137.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(865.5 137.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "432")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(1065.5 137.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "58")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(1265.5 137.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-1")), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(65.5 192.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sample_01b")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(265.5 192.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10029885")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(465.5 192.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "One-week program")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(665.5 192.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(865.5 192.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "432")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(1065.5 192.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "58")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(1265.5 192.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(65.5 82.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "viallabel")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(265.5 82.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "pid")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(465.5 82.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "key___ani_rand_group")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(665.5 82.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "registration___sex")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(865.5 82.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "terminal_weight___mg")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(1065.5 72.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "vo_2_max_test___vo_2_"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19.2
  }, "max_1")), /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(1265.5 72.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "calculated_variables___"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19.2
  }, "vo_2_max_change")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "402 291.38 402 259.38 1 259.38 1 131.38 51 131.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 51,
    cy: 131.38,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 402,
    cy: 290.88,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 45.05,
    y: 181.43,
    width: 9.9,
    height: 9.9,
    transform: "translate(-117.14 89.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 1108.05,
    y: 284.93,
    width: 9.9,
    height: 9.9,
    transform: "translate(121.02 871.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "1113 292.38 1113 237.38 23 237.38 23 186.38 51 186.38"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(620.96 32.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Phenotypic data"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(265.96 505.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st11",
    x: 0,
    y: 0
  }, "RNA"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 75.35,
    y: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    className: "st11",
    x: 90,
    y: 0
  }, "seq results"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(933.76 505.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Metabolomics results"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVialLabelDataLinkageExample);
export default __webpack_public_path__ + "static/media/vial_label_data_linkage_example.400bb50d5b6de9131b6c546e02eba2b0.svg";
export { ForwardRef as ReactComponent };